import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";

const BG = "https://images.unsplash.com/photo-1700226034367-2fb120f48dfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwaW50ZXJpb3IlMjBkZXNpZ24lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4NzExMzkwMHww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@gazedecor.in");
  const [password, setPassword] = useState("Gaze@2026");

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden">
        <img src={BG} alt="Interior" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#1A1A1A]/60 via-[#1A1A1A]/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white gz-fade">
          <p className="text-sm uppercase tracking-[0.3em] opacity-80">Gaze Decor</p>
          <h1 className="font-serif-elegant text-6xl leading-[1.05] mt-3">Crafted<br/>Interiors,<br/>Refined Books.</h1>
          <p className="mt-6 max-w-md text-white/80 text-sm">Billing, customers, WhatsApp campaigns and accounting in one calm workspace.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-background">
        <Card className="w-full max-w-md p-8 border-border shadow-sm gz-fade" data-testid="login-card">
          <div className="mb-8">
            <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Sign In</p>
            <h2 className="font-serif-elegant text-4xl mt-2">Welcome to <span className="brand-gradient-text">Gaze Decor</span></h2>
            <p className="text-sm text-muted-foreground mt-2">Enter your credentials to continue.</p>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@gazedecor.in" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={e=>setPassword(e.target.value)} required />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-primary hover:bg-[#984D38] text-white h-11 rounded-md">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
            <p className="text-xs text-muted-foreground text-center">Default admin: admin@gazedecor.in / Gaze@2026</p>
          </form>
        </Card>
      </div>
    </div>
  );
}
